import React, { useState } from "react";

import LevelTestReportCard from "./LevelTestReportCard";
import "./LevelTestInvite.css";

// 이번 호 레벨테스트 안내. 코드를 받았는데 아직 안 본 학생에게만 뜬다.
//
// 학원이 코드를 나눠 줘도 학생에게 전달이 안 되는 일이 많다. 학생 화면에 코드가
// 그대로 떠 있고 누르면 응시 화면으로 넘어가야 받은 코드가 실제로 쓰인다.
// 아직 아무도 응시하지 않은 학원은 지금까지 이 화면에 아무것도 안 떴다.
//
// **뒤에 깔리는 것은 진짜 성적표 컴포넌트다**(LevelTestReportCard). 흉내낸 그림을
// 그리면 크기와 모양이 조금씩 어긋나고, 그러면 '이런 걸 받는다' 는 말이 믿기지
// 않는다. 점수·영역별 막대·남은 여정·지난 응시까지 그대로 그린 뒤 흐리게 덮는다.
// 숫자는 예시이고, 그렇게 밝힌다.
const SAMPLE_LATEST = {
  session_id: "sample",
  taken_month: "2026-08",
  stage: 8,
  stage_name: "중등 아카데믹",
  score_percent: 37,
  right_count: 28,
  total_count: 75,
  is_finished: true,
  report_url: "",
  areas: [
    { area: "어휘", pct: 40 },
    { area: "듣기", pct: 53 },
    { area: "문법", pct: 7 },
    { area: "독해", pct: 50 },
    { area: "서술형", pct: 0 },
  ],
};

const SAMPLE_JOURNEY = [
  { label: "수능 필수 3,000단어", state: "pending", check_url: "" },
  { label: "고등 문법", state: "pending", check_url: "" },
  { label: "고등 듣기", state: "pending", check_url: "" },
  {
    label: "수능형 독해",
    state: "estimated",
    months: 8,
    target_year: 2027,
    target_month: 4,
  },
];

const SAMPLE_RESULTS = [
  { ...SAMPLE_LATEST, session_id: "sample-1" },
  { ...SAMPLE_LATEST, session_id: "sample-2", score_percent: 45 },
];

// 요약 카드도 같은 표기를 쓴다. 한쪽만 '8월', 다른 쪽만 '2026. 08' 이면 어긋나 보인다.
export const formatMonthLabel = (month) =>
  month && month.length >= 7 ? `${Number(month.slice(5, 7))}월` : "이번 달";

const LevelTestInvite = ({ invite }) => {
  const [isCopied, setIsCopied] = useState(false);

  if (!invite || !invite.code) {
    return null;
  }

  const copyCode = () => {
    const onDone = () => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(invite.code).then(onDone, onDone);
      return;
    }

    // 클립보드를 막는 브라우저도 있다. 실패해도 코드는 화면에 떠 있다.
    onDone();
  };

  return (
    <section className="level-test-invite">
      {/* 예시 성적표. 읽으라고 두는 것이 아니라 무엇을 받게 되는지 보여주는
          자리라 흐리게 두고 손도 안 닿게 한다. 카드의 높이도 이 블록이 정한다. */}
      <div className="level-test-invite__ghost" aria-hidden="true">
        <LevelTestReportCard
          latest={SAMPLE_LATEST}
          results={SAMPLE_RESULTS}
          journey={SAMPLE_JOURNEY}
        />
      </div>

      {/* 읽고 누르는 것은 가운데에 판으로 얹는다. */}
      <div className="level-test-invite__body">
        <div className="level-test-invite__badge">
          {formatMonthLabel(invite.month)} 레벨테스트가 열렸어요
        </div>
        <p className="level-test-invite__text">
          아래 응시코드로 시험을 보면 어휘 · 듣기 · 문법 · 독해 · 서술형 성적과
          수능까지 남은 여정을 받아요. 뒤에 흐리게 보이는 것은 예시예요.
        </p>

        <button
          type="button"
          className="level-test-invite__code"
          onClick={copyCode}
        >
          <span className="level-test-invite__code-label">내 응시코드</span>
          <b className="level-test-invite__code-value">{invite.code}</b>
          <span className="level-test-invite__code-copy">
            {isCopied ? "복사됨" : "복사"}
          </span>
        </button>

        <div className="level-test-invite__actions">
          <a
            className="level-test-invite__go"
            href={invite.test_url}
            target="_blank"
            rel="noreferrer"
          >
            {formatMonthLabel(invite.month)} 호 응시하러 가기 ›
          </a>
          {invite.sample_report_url && (
            <a
              className="level-test-invite__sample"
              href={invite.sample_report_url}
              target="_blank"
              rel="noreferrer"
            >
              리포트 예시 보기
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default LevelTestInvite;
